@if (showDisclaimer()) {
  <div class="disclaimer-container">
    <div class="modal fade" [ngClass]="{ 'show': showDisclaimer()}" aria-labelledby="disclaimerModal" aria-hidden="true"  tabindex="-1" style="background: rgba(255,255,255,0.5);">
      <div class="modal-dialog modal-dialog-centered">
        <div class="modal-content disclaimer-modal-content">
          <div class="modal-header" style="border-bottom: none; padding-bottom: 0;">
            <h1 class="modal-title disclaimer-title" id="disclaimerModal">{{'main.disclaimers.disclaimer' | translate }}</h1>
          </div>
          <div class="modal-body" style="overflow: hidden;">
            <p style="line-height: 120%;" innerHTML="{{'main.disclaimers.competition_law' | translate }}"></p>
          </div>
          <div class="modal-footer">
            @if (showExitButton()) {
              <button type="button" aria-label="Close" class="btn btn-transparent uppercase" (click)="exitApplication()" >
                {{getExitButtonText()}}
              </button>
            }
            &nbsp;
            <button type="button" class="btn btn-transparent uppercase" (click)="recordDisclaimerAcceptance()" >
              {{getButtonText()}}
            </button>
          </div>
        </div>
      </div>
    </div>
  </div>
}
